/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import PropTypes from 'prop-types';

import SociollaText from '@components/sociolla/SociollaText';

import Colors from '@global/colors';

const propTypes = {
  style: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.number,
  ]),
  activeColor: PropTypes.string,
  bordered: PropTypes.bool,
  title: PropTypes.string,
  titleBold: PropTypes.bool,
  titleStyle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.number,
  ]),
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  totalStyle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.number,
  ]),
  desc: PropTypes.string,
  descStyle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.number,
  ]),
  totalComponent: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  onDetail: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
};

const defaultProps = {
  style: {},
  activeColor: Colors.blue0,
  bordered: false,
  title: '',
  titleBold: false,
  titleStyle: {},
  total: 0,
  totalStyle: {},
  desc: '',
  descStyle: {},
  totalComponent: false,
  onDetail: false,
};

const TextChart = (props) => {
  const {
    style = {},
    activeColor = Colors.blue0,
    bordered = false,
    title = '',
    titleBold = false,
    titleStyle = {},
    total = 0,
    totalStyle = {},
    desc = '',
    descStyle = {},
    totalComponent = false,
    onDetail = false,
  } = props;

  return (
    <View style={[styles.textWrapper, style, bordered ? styles.bordered : {}]}>
      <SociollaText
        type={titleBold ? 'medium' : 'regular'}
        style={[styles.titleText, titleStyle]}>
        {title}
      </SociollaText>
      {totalComponent ? (
        <>{totalComponent}</>
      ) : (
        <SociollaText
          type="bold"
          style={[styles.totalText, { color: activeColor }, totalStyle]}>
          {total}
          {onDetail ? (
            <TouchableOpacity
              activeOpacity={0.8}
              style={styles.detailText}
              onPress={onDetail}>
              <SociollaText style={[styles.detailText, { color: activeColor }]}>
                see detail
              </SociollaText>
            </TouchableOpacity>
          ) : (
            false
          )}
        </SociollaText>
      )}
      {desc ? (
        <SociollaText style={[styles.descText, descStyle]}>{desc}</SociollaText>
      ) : (
        false
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  textWrapper: {
    width: '100%',
    marginVertical: 10,
    paddingBottom: 15,
  },
  titleText: {
    fontSize: 13,
    marginBottom: 5,
  },
  totalText: {
    fontSize: 26,
    color: Colors.blue0,
  },
  descText: {
    fontSize: 10,
    color: Colors.grey1,
  },
  bordered: {
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
  },
  detailText: { fontSize: 12, marginLeft: 15 },
});

TextChart.propTypes = propTypes;
TextChart.defaultProps = defaultProps;

export default React.memo(TextChart, (prev, next) => prev == next);
